import { PersonRatingContainer } from "../containers/PersonRatingContainer";

export const PersonToMeRatingPage = () => (
    <PersonRatingContainer type="PERSON_TO_ME"/>
)